import React from 'react';
import { InputLabel } from '../common-components/input-label';
import { CheckBoxInput } from '../input';

export const CheckBox = ({
	ariaLabel,
	label,
	required,
	errors,
	name,
	help,
	onChange,
	onFocus,
	checked = false,
}: CheckBoxInput) => {
	return (
		<>
			<input
				type="checkbox"
				name={name}
				id={name}
				className="rounded-lg flex accent-brand w-8 h-8"
				onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
					if (onChange) {
						onChange(event.target.checked);
					}
				}}
				onFocus={(event: React.FocusEvent<HTMLInputElement>) => {
					if (onFocus) {
						onFocus(event);
					}
				}}
				checked={checked}
			/>
			<InputLabel
				ariaLabel={ariaLabel}
				label={label}
				required={required}
				errors={errors}
				name={name}
				help={help}
			/>
		</>
	);
};
